import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as base64_decode, encode as base64_encode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const mapSeverityToBg = (severity) => {
  const sev = String(severity || '').toLowerCase();
  if (sev === 'success') return 'success';
  if (sev === 'warning' || sev === 'warn') return 'warning';
  if (sev === 'error' || sev === 'danger' || sev === 'critical' || sev === 'crit') return 'danger';
  return 'info';
};

const adaptInboxItem = (row) => {
  const createdAt = row?.created_at ? new Date(row.created_at) : null;
  const readAt = row?.read_at ? String(row.read_at) : null;

  return {
    key: row?.id,
    id: row?.id,
    type: row?.type || '',
    titulo: row?.title || '',
    texto: row?.body || '',
    link: row?.cta_url || null,
    fundo: mapSeverityToBg(row?.severity),
    data_hora_inicio: createdAt,
    data_hora_leitura: readAt,
    _raw: row,
  };
};

const getSession = () => {
  const storageRaw = sessionStorage.getItem('ddesp');
  if (!storageRaw) return { emp: 0, uid: 0, token: '' };

  const usersRt = base64_decode(storageRaw);
  const users = JSON.parse(usersRt);
  return {
    emp: users?.[0] || 0,
    uid: users?.[3] || 0,
    token: users?.[14] || '',
  };
};

const isTenantNotificationsAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleTenantNotificationsError = (xhr, reject, rejectMessage) => {
  if (isTenantNotificationsAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  const details = xhr && (xhr.responseJSON || xhr.responseText || xhr.statusText);
  reject([400, { message: rejectMessage, details }]);
};

const ajaxTenantNotificationsEvent = (
  type,
  ll,
  dd,
  tk,
  parseType = 'jsonBase64',
  rejectMessage = 'Falha na requisição',
  transformResponse = null,
) => new Promise((resolve, reject) => {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
      type,
      dataType: 'text',
      headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: {
        pp: base64_encode('tenantNotifications'),
        ll: base64_encode(ll),
        dd: base64_encode(JSON.stringify(dd)),
        tk,
      },
      success: async function (data) {
        try {
          let responseData = typeof data === 'string' ? data.trim() : data;

          if (typeof responseData === 'string' && responseData.startsWith('"') && responseData.endsWith('"')) {
            responseData = JSON.parse(responseData);
          }

          if (parseType === 'jsonBase64') {
            responseData = JSON.parse(base64_decode(responseData));
          } else if (parseType === 'base64') {
            responseData = base64_decode(responseData);
          }

          if (transformResponse) {
            responseData = transformResponse(responseData);
          }

          resolve([200, responseData]);
        } catch {
          reject([400, { message: 'Resposta inválida' }]);
        }
      },
      error: function (xhr) {
        handleTenantNotificationsError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: String(err) }]);
  }
});

const RestTenantNotificationsGet = async (config) => {
  const caminho = (config?.dest || '').trim();
  const { emp, uid, token } = getSession();

  switch (caminho) {
    case 'inbox':
      return ajaxTenantNotificationsEvent(
        'Get',
        'inbox',
        [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config?.dataPost || {}))],
        token,
        'jsonBase64',
        'Falha na requisição',
        (rows) => (rows || []).map(adaptInboxItem),
      );
    case 'unreadCount':
      return ajaxTenantNotificationsEvent(
        'Get',
        'unreadCount',
        [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))],
        token,
      );
    case 'banner':
      return ajaxTenantNotificationsEvent(
        'Get',
        'banner',
        [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify({}))],
        token,
        'jsonBase64',
        'Falha na requisição',
        (rows) => {
          const items = (rows || []).map(adaptInboxItem);
          const first = items[0] || null;

          if (!first) {
            return [];
          }

          return [{
            fundo: first.fundo || 'info',
            icone: 'mdi mdi-bell',
            cor_fonte: 'text-secondary',
            texto: first.texto || first.titulo || '',
            link: first.link || null,
          }];
        },
      );
    case 'history':
      return ajaxTenantNotificationsEvent(
        'Get',
        'history',
        [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config?.dataPost || {}))],
        token,
        'jsonBase64',
        'Falha na requisição',
        (rows) => (rows || []).map(adaptInboxItem),
      );

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

const RestTenantNotificationsPost = async (config) => {
  const { emp, uid, token } = getSession();
  const Arr_ = JSON.parse(config.data);
  const caminho = (Arr_?.dest || '').trim();
  const payload = Arr_?.dataPost || {};

  switch (caminho) {
    case 'markRead':
      return ajaxTenantNotificationsEvent(
        'Post',
        'markRead',
        [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(payload))],
        token,
      );

    case 'markReadBatch':
      return ajaxTenantNotificationsEvent(
        'Post',
        'markReadBatch',
        [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(payload))],
        token,
      );

    case 'dismiss':
      return ajaxTenantNotificationsEvent(
        'Post',
        'dismiss',
        [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(payload))],
        token,
      );

    case 'archive':
      return ajaxTenantNotificationsEvent(
        'Post',
        'archive',
        [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(payload))],
        token,
      );

    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export { RestTenantNotificationsGet, RestTenantNotificationsPost };
